<script lang="ts" setup="">
import { NIcon } from '@novonordisk/studyhub-novoui/vue'

defineProps<{
  messages: string[]
  type: 'error' | 'info'
}>()
</script>

<template>
  <div
    data-test="feedback-container"
    :class="{
      'text-alert-enabled': type === 'error',
      'text-general-secondary': type === 'info',
    }"
    class="text-ui-label-12 mx-4 mt-1"
  >
    <NIcon
      v-if="type === 'error'"
      data-test="error-icon"
      variant="small"
      :size="12"
      class="fill-alert-enabled -mt-[3px] mr-0.5 inline-block shrink-0"
      icon="warning"
    />
    <span data-test="feedback-message">{{ messages[0] }}</span>
  </div>
</template>
